import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";
import { GRAPHQL_URL } from "./endpoints";

const client = new ApolloClient({
  link: new HttpLink({
    uri: GRAPHQL_URL,
    fetch,
  }),
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions: {
    watchQuery: { fetchPolicy: "no-cache" },
    query: { fetchPolicy: "no-cache" },
  },
});

export default client;
